import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { deleteCreative, editCreativeUpload, getCreativeById, getCreatives, postCreativeUpload } from '../thunks/creativeUploadThunk';

const initialState = {
    isGetCreativeLoading: false,
    isGetCreativeByIdLoading: false,
    isDeleting: false,
    isDownloading: false,
    isUploading: false,
    isUploadOpen: false,
    error: null,
    creatives: [],
    creativeData: [],
    creative: {},
    selectedCreatives: [],
    isSelectedAll: false,
    selectedCreative: [],
    currentPage: 1,
    pageSize: 10,
    totalPages: 0,
    modalType: 'Create Creative'
};

const creativeUpload = createSlice({
    name: 'creativeUpload',
    initialState: initialState,
    reducers: {
        resetCreative(state,action){
            state.creative = {};
        },
        handleSelected(state, action) {
            let updatedSelected = [];
            const { selectedId } = action.payload;
            const isSelected = state.selectedCreatives.includes(selectedId);
            if (action.payload.type === 'row_selected') {
                if (isSelected) {
                    updatedSelected = state.selectedCreatives.filter(id => id !== selectedId);
                } else {
                    updatedSelected = [...state.selectedCreatives, selectedId];
                }
            } else if (action.payload.type === 'selected_all') {
                updatedSelected = state.isSelectedAll ? [] : state.creatives.map(item => item.id);
            } else if(action.payload.type === 'unselect') updatedSelected = [];
            const isSelectedAll = state.creatives.length === updatedSelected.length;
            return {
                ...state,
                isSelectedAll,
                selectedCreatives: updatedSelected
            };

        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        handleSearch: (state, action) => {
            const { searchTerm } = action.payload;
            const filteredFiles = state.creativeData.filter(file => {
                const creativeData = Object.values(file)
                    .map(value => (typeof value === 'string' ? value.trim().toLowerCase() : value))
                    .join(' ');
                const trimmedSearchTerm = searchTerm?.trim()?.toLowerCase();
                return creativeData.includes(trimmedSearchTerm);
            });
            return {
                ...state,
                creatives: filteredFiles,
                totalPages: Math.ceil(filteredFiles.length / (state.pageSize ?? 1)),
                currentPage: 1
            };
        },
        setSelectedAllFalse(state, action) {
            return {
                ...state,
                isSelectedAll: false
            };
        },
        handleUploadModal(state,action){
            const { type } = action.payload;
            return {
                ...state,
                isUploadOpen: !state.isUploadOpen,
                modalType: type==='create' ? 'Create Creative' : 'Edit Creative'
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCreatives.fulfilled, (state, action) => {
                state.creatives = action.payload?.result;
                state.creativeData = action.payload?.result;
                state.totalPages = Math.ceil((action.payload?.result.length) / state.pageSize);
                state.error = null;
                state.isGetCreativeLoading = false;
            })
            .addCase(getCreatives.pending, (state, action) => {
                state.isGetCreativeLoading = true;
                state.error = null;
            })
            .addCase(getCreatives.rejected, (state, action) => {
                state.isGetCreativeLoading = false;
                state.error = action.payload;
            })
            .addCase(getCreativeById.fulfilled, (state, action) => {
                state.creative = action.payload?.result;
                state.error = null;
                state.isGetCreativeByIdLoading = false;
            })
            .addCase(getCreativeById.pending, (state, action) => {
                state.isGetCreativeByIdLoading = true;
                state.error = null;
            })
            .addCase(getCreativeById.rejected, (state, action) => {
                state.isGetCreativeByIdLoading = false;
                state.error = action.payload;
            })
            .addCase(postCreativeUpload.fulfilled, (state, action) => {
                state.error = null;
                state.isUploading = false;
                if(action.payload.status_code=== 200){
                    toast.success('Creative uploaded successfully.');
                }
            })
            .addCase(postCreativeUpload.pending, (state, action) => {
                state.isUploading = true;
                state.error = null;
            })
            .addCase(postCreativeUpload.rejected, (state, action) => {
                state.isUploading = false;
                state.error = action.payload;
            })
            .addCase(deleteCreative.fulfilled, (state, action) => {
                state.error = null;
                state.isUploading = false;
                if(action.payload.status_code === 200){
                    toast.success(`${state.selectedCreatives.length > 1 ? 'Creatives' : 'Creative'} deleted successfully.`);
                }
            })
            .addCase(deleteCreative.pending, (state, action) => {
                state.isUploading = true;
                state.error = null;
            })
            .addCase(deleteCreative.rejected, (state, action) => {
                state.isUploading = false;
                state.error = action.payload;
            })
            .addCase(editCreativeUpload.fulfilled, (state, action) => {
                state.error = null;
                state.isUploading = false;
                if(action.payload.status_code=== 200){
                    toast.success('Asset updated successfully.');
                }
            })
            .addCase(editCreativeUpload.pending, (state, action) => {
                state.isUploading = true;
                state.error = null;
            })
            .addCase(editCreativeUpload.rejected, (state, action) => {
                state.isUploading = false;
                state.error = action.payload;
            });
    }
});
export const creativeUploadActions = creativeUpload.actions;
export default creativeUpload.reducer;